import React from 'react';
import { useParams } from 'react-router-dom';

import { useAppSelector } from 'store/hooks';

import { USER_ROLES } from 'constants/common';

import { userSelector } from 'store/auth/selectors';

import { useInboxCount } from './InboxSection.hooks';

import InboxSection from './InboxSection';

const InboxSectionContainer = () => {
  const params = useParams();

  const user = useAppSelector(userSelector);

  const isRootAdmin = user.role === USER_ROLES.ROOT_ADMIN;

  const [
    loading,
    lessonsRatingsCount,
    lessonsReportsCount,
    studentReviewCount,
    unsibscribeReasonsCount,
    surveysCount,
  ] = useInboxCount(params.id);

  return (
    <InboxSection
      isRootAdmin={isRootAdmin}
      loading={loading}
      lessonsRatingsCount={lessonsRatingsCount}
      lessonsReportsCount={lessonsReportsCount}
      studentReviewCount={studentReviewCount}
      unsibscribeReasonsCount={unsibscribeReasonsCount}
      surveysCount={surveysCount}
    />
  );
};

export default InboxSectionContainer;
